import React, {useState} from "react";
import searchImg from "../../Assets/images/Search.svg";
import SearchList from "../SearchList";

const Search = ({data}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [subEntityEnable, setSubEntityEnable] = useState(true);
  const [tagEnable, setTagEnable] = useState(true);
  const [methodEnable, setPathEnable] = useState(true);

  const handleSearch = (event) => {
    const term = event.target.value;
    setSearchTerm(term);
    const results=[];

    // Check for each subentity name if it is same
    // Then check the tag names if that is same then add
    // Then check methods inside each and if that is same then add that
    // Check for subEntity
    data.forEach((element) => {
      if (element.subEntities.length>0) {
        element.subEntities.forEach((subEntity)=>{
          // subEntity name added
          // if (subEntityEnable&&subEntity.name.toLowerCase().includes(term.toLowerCase())&&!results.includes(subEntity.name)) {
          //   if (subEntity.tags&&subEntity.tags.length>1) {
          //     results.push([subEntity.name, subEntity.id]);
          //   }
          // }
          // check for tags
          if (subEntity.tags&&subEntity.tags.length>0) {
            subEntity.tags.forEach((tag)=>{
              if (tagEnable&&tag.name.toLowerCase().includes(term.toLowerCase())) {
                results.push([tag.name, tag.id]);
              }
              if (methodEnable&&tag.paths&&tag.paths.length>0) {
                tag.paths.forEach((path)=>{
                  if (path.method.name.toLowerCase().includes(term.toLowerCase())) {
                    results.push([path.method.name, path.id]);
                  }
                });
              }
            });
          }
        });
      }
      if (element.schemas&&element.schemas.length>0) {
        Object.keys(element.schemas[0]).forEach(function(key, index) {
          if (key.toLowerCase().includes(term.toLowerCase())) {
            results.push([key, key]);
          }
        });
      }
    });
    if (term==""||term==" ") {
      setSearchResults([]);
    } else {
      setSearchResults(results);
    }
  };

  return (
    <div className="search-container">
      <div className="search-bar">
        <span className="search-icon">
          <img src={searchImg} alt="" />
        </span>
        <input
          id="input-search"
          placeholder="Search"
          value={searchTerm}
          onChange={handleSearch}
        />
      </div>
      {searchResults.length ==0&&searchTerm!=""? (
        <p>No Search Results Found For &quot;{searchTerm}&quot; </p>
      ):(
        <div className="search-results">
          <SearchList searchResults={searchResults}/>
        </div>
      )}
    </div>
  );
};

export default Search;
